import AVOCADO_IMAGE from '../../assets/images/hot_dog_game/avocado.png';
import BACON_IMAGE from '../../assets/images/hot_dog_game/bacon.png';
import CHEESE_IMAGE from '../../assets/images/hot_dog_game/cheese.png';
import DILL_PICKLE_IMAGE from '../../assets/images/hot_dog_game/pickle.png';
import EGG_IMAGE from '../../assets/images/hot_dog_game/egg.png';
import GREEN_ONIONS_IMAGE from '../../assets/images/hot_dog_game/green_onions.png';
import HOT_SAUCE_IMAGE from '../../assets/images/hot_dog_game/hot_sauce.png';
import JALAPENO_IMAGE from '../../assets/images/hot_dog_game/jalapeno.png';
import KETCHUP_IMAGE from '../../assets/images/hot_dog_game/ketchup.png';
import MUSTARD_IMAGE from '../../assets/images/hot_dog_game/mustard.png';
import ONION_IMAGE from '../../assets/images/hot_dog_game/onion.png';
import PINEAPPLE_IMAGE from '../../assets/images/hot_dog_game/pineapple.png';
import RELISH_IMAGE from '../../assets/images/hot_dog_game/relish.png';
import SALT_IMAGE from '../../assets/images/hot_dog_game/salt.png';
import TOMATO_IMAGE from '../../assets/images/hot_dog_game/tomato.png';
import WASABI_IMAGE from '../../assets/images/hot_dog_game/wasabi.png';

export enum ToppingsEnum {
    A = 'Avocado',
    B = 'Bacon',
    C = 'Cheese',
    D = 'Dill pickles',
    E = 'Egg',
    G = 'Green onions',
    H = 'Hot sauce',
    J = 'Jalapenos',
    K = 'Ketchup',
    M = 'Mustard',
    O = 'Onions',
    P = 'Pineapple',
    R = 'Relish',
    S = 'Salt',
    T = 'Tomato',
    W = 'Wasabi',
}

export enum ToppingStatus {
    GREEN = 'Found all instances of this topping',
    YELLOW = 'This topping is still wanted',
    GRAY = 'This topping is unwanted',
}

export const TOPPING_IMAGES = {
    [ToppingsEnum.A]: AVOCADO_IMAGE,
    [ToppingsEnum.B]: BACON_IMAGE,
    [ToppingsEnum.C]: CHEESE_IMAGE,
    [ToppingsEnum.D]: DILL_PICKLE_IMAGE,
    [ToppingsEnum.E]: EGG_IMAGE,
    [ToppingsEnum.G]: GREEN_ONIONS_IMAGE,
    [ToppingsEnum.H]: HOT_SAUCE_IMAGE,
    [ToppingsEnum.J]: JALAPENO_IMAGE,
    [ToppingsEnum.K]: KETCHUP_IMAGE,
    [ToppingsEnum.M]: MUSTARD_IMAGE,
    [ToppingsEnum.O]: ONION_IMAGE,
    [ToppingsEnum.P]: PINEAPPLE_IMAGE,
    [ToppingsEnum.R]: RELISH_IMAGE,
    [ToppingsEnum.S]: SALT_IMAGE,
    [ToppingsEnum.T]: TOMATO_IMAGE,
    [ToppingsEnum.W]: WASABI_IMAGE,
};
